import { render, staticRenderFns } from "./prontuarios.vue?vue&type=template&id=059a30c3&scoped=true"
import script from "./prontuarios.vue?vue&type=script&lang=js"
export * from "./prontuarios.vue?vue&type=script&lang=js"
import style0 from "./prontuarios.vue?vue&type=style&index=0&id=059a30c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059a30c3",
  null
  
)

export default component.exports